import styled from 'styled-components';

const ConfirmationGrid = styled.div`
  .promotions-col {
    height: 100%;

    & > .row:last-child {
      height: 50%;
    }

    .promotions-container {
      height: 100%;
    }

    .carousel-item-height {
      height: ${props => props.theme.confirmationCarousel.mobileHeight};
      overflow: hidden;

      @media screen and (min-width: ${props =>
          props.theme.breakpoints.extraSmall}) {
        height: ${props => props.theme.confirmationCarousel.largeMobileHeight};
      }
      @media screen and (min-width: ${props => props.theme.breakpoints.small}) {
        height: ${props => props.theme.confirmationCarousel.tabletHeight};
      }
      @media screen and (min-width: ${props => props.theme.breakpoints.large}) {
        height: ${props => props.theme.confirmationCarousel.desktopHeight};
      }
      @media screen and (max-width: ${props => props.theme.breakpoints.small}) {
        overflow-y: auto;
      }
    }
  }

  & > .row:last-child {
    margin-bottom: 1em;
  }

  & > .row {
    height: 100%;

    div[class*='col-']:first-child {
      margin-bottom: 2em;
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.large}) {
    & > .row {
      div[class*='col-']:first-child {
        margin-bottom: 0;
      }
    }
  }
`;

export default ConfirmationGrid;
